/**
 * Origine réelle du parent (panneau d'extension ou page Doctolib).
 *
 * Pourquoi ce module (17/09/2026) : pour répondre à son parent, l'iframe
 * déduisait l'origine de `document.referrer`. Or ce référent est ABSENT dans
 * plusieurs cas courants (panneau restauré, navigation interne, politique de
 * référent du navigateur). Le repli valait alors `window.location.origin`,
 * c'est-à-dire medipocket.fr — une origine qui n'est PAS celle du parent : le
 * navigateur refusait donc silencieusement de délivrer le message, et
 * « Compléter Doctolib » ne faisait rien, de façon intermittente.
 *
 * Le seul renseignement fiable est l'origine des messages REÇUS du parent
 * (`event.origin`), déjà validée par `isAllowedOrigin`. On la retient ici pour
 * que les envois l'utilisent, plutôt que de la redéduire.
 *
 * Jamais de repli sur '*' : ces messages transportent la note, donc des données
 * de santé.
 */

let origineParent = null;

/** Appelé à chaque message reçu d'une origine DÉJÀ validée. */
export function memoriserOrigineParent(origin) {
  if (origin && origin !== 'null') origineParent = origin;
}

/**
 * Origine à utiliser pour parler au parent : celle apprise des messages reçus,
 * sinon le référent, sinon rien (l'appelant décide quoi faire).
 */
export function origineParentPourEnvoi() {
  if (origineParent) return origineParent;
  try {
    if (document.referrer) return new URL(document.referrer).origin;
  } catch (_) { /* référent illisible */ }
  return null;
}
